import React, { useEffect, useState } from "react";
import banner from "../../../assets/Banners/banner_netuno-gracias.png";
import ButtonGeneric from "../../../components/Buttons/ButtonGeneric";
import { UseContextApp } from "../../../Global/Context/appContext.js";
import { PaperClipIcon, CreditCardIcon } from '@heroicons/react/solid'
import StepsGeneric from "../../../components/Nav/StepsGeneric.jsx";
import { useLocation, useNavigate } from "react-router-dom";



function DomiciliacionConfirmation() {

    const navigate = useNavigate();
    const [{ user }] = UseContextApp()

    const [ticket, setTicket] = useState({ numero: localStorage.getItem('ticket') })
    const [titular, setTitular] = useState({ numero: localStorage.getItem('titular') })
    const [cuenta, setCuenta] = useState({ numero: localStorage.getItem('cuenta') })
    const [mop, setMop] = useState({ numero: localStorage.getItem('mop') })
    const [mopNro, setMopNro] = useState({ numero: localStorage.getItem('mopNro') })
    const [titularMop, setTitularMop] = useState({ numero: localStorage.getItem('titularMop') })
    const [deuda, setDeuda] = useState({ numero: localStorage.getItem('deuda') })
    const [refreshPage, setRefreshPage] = useState(false);

    const atras = () => { navigate('/cuenta/pagos'); }
    const Print = () => {
        window.print();

         /*let printContents = document.getElementById('print-mount').innerHTML;
         let originalContents = document.body.innerHTML;
         document.body.innerHTML = printContents;
         window.print();
         document.body.innerHTML = originalContents;
         navigate(0);*/
    }


    useEffect(() => {
        
    }, []);

    return (
        <div className=" relative bg-[#f3f4f6]">
            <div className="flex max-w-7xl mx-auto  pt-6 justify-center">
                <div className="flex w-full lg:w-full px-4 pt-5 gap-5 flex-col">
                    <div className="bg-white  rounded-md shadow mb-[100px]">
                        <div className=" flex justify-center items-center flex-col gap-6 ">
                            <div className="w-full flex-col flex gap-5">
                                <main className="bg-white px-4  md:pb-0 sm:px-6 sm:pt-24 md:px-0 md:py-0">
                                    <div className="pl-5 flex flex-col gap-4 mx-auto">
                                        <div className="w-full flex justify-center items-center rounded-md  pt-5">
                                            <img className="w-[50%] object-contain h-[400px] " src={banner} alt="" />
                                        </div>
                                        <div id="print-mount" className="pl-5 flex flex-col gap-4 mx-auto">
                                            <div className="grid place-content-center pla">
                                                <div className="max-w-xl flex flex-col justify-center ">
                                                    <p className="mt-2 text-center text-2xl md:text-4xl font-extrabold tracking-tight sm:text-5xl">
                                                        Solicitud de Domiciliación Exitosa
                                                    </p>
                                                    <dl className=" text-center mt-6 md:mt-0 text-sm font-medium">
                                                        <br></br>Estimado cliente, le informamos que estamos validando la solicitud. Concluido el proceso de validación, en el lapso máximo de 72 horas le notificaremos a su dirección de correo electrónico.
                                                        <br></br>Podrás consultar el estatus solicitud por Bruno con el N° de ticket.
                                                    </dl>
                                                    <dl style={deuda.numero > 0 ? { display: '' } : { display: 'none' }} className=" text-center mt-6 md:mt-0 text-lg font-medium text-[red] hover:text-[red]">
                                                        <br></br>Importante: para realizar un pago inmediato a tu cuenta NetUno, ingresa en la opción pagos.
                                                    </dl>
                                                    <ul role="list" className="border border-gray-200 mt-4 rounded-md divide-y divide-gray-200">
                                                        <li className="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                                                            <div className="w-0 flex-1 flex items-center">
                                                                <PaperClipIcon className="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true" />
                                                                <span className="ml-2 flex-1 w-0 truncate">Nro. de Ticket: </span>
                                                            </div>
                                                            <div className="ml-4 flex-shrink-0">
                                                                <p className="font-medium text-[#5ab9e5] hover:text-[#5ab9e5] ">
                                                                    {ticket.numero}
                                                                </p>
                                                            </div>
                                                        </li>
                                                        {
                                                            titular.numero &&
                                                            <li className="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                                                                <div className="w-0 flex-1 flex items-center">
                                                                    <CreditCardIcon className="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true" />
                                                                    <span className="ml-2 flex-1 w-0 truncate">Titular NetUno: </span>
                                                                </div>
                                                                <div className="ml-4 flex-shrink-0">
                                                                    <p className="font-medium text-[#5ab9e5] hover:text-[#5ab9e5] ">
                                                                        {titular.numero}
                                                                    </p>
                                                                </div>
                                                            </li>
                                                        }
                                                        {
                                                            cuenta.numero &&
                                                            <li className="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                                                                <div className="w-0 flex-1 flex items-center">
                                                                    <CreditCardIcon className="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true" />
                                                                    <span className="ml-2 flex-1 w-0 truncate">Cuenta: </span>
                                                                </div>
                                                                <div className="ml-4 flex-shrink-0">
                                                                    <p className="font-medium text-[#5ab9e5] hover:text-[#5ab9e5] ">
                                                                        {cuenta.numero}
                                                                    </p>
                                                                </div>
                                                            </li>
                                                        }
                                                        {
                                                            mop.numero &&
                                                            <li className="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                                                                <div className="w-0 flex-1 flex items-center">
                                                                    <CreditCardIcon className="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true" />
                                                                    <span className="ml-2 flex-1 w-0 truncate">Método de Pago: </span>
                                                                </div>
                                                                <div className="ml-4 flex-shrink-0">
                                                                    <p className="font-medium text-[#5ab9e5] hover:text-[#5ab9e5] ">
                                                                        {mop.numero}
                                                                    </p>
                                                                </div>
                                                            </li>
                                                        }
                                                        {
                                                            mopNro.numero &&
                                                            <li className="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                                                                <div className="w-0 flex-1 flex items-center">
                                                                    <CreditCardIcon className="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true" />
                                                                    <span className="ml-2 flex-1 w-0 truncate">Nro. Método Pago: </span>
                                                                </div>
                                                                <div className="ml-4 flex-shrink-0">
                                                                    <p className="font-medium text-[#5ab9e5] hover:text-[#5ab9e5] ">
                                                                        {mopNro.numero}
                                                                    </p>
                                                                </div>
                                                            </li>
                                                        }
                                                        {
                                                            titularMop.numero &&
                                                            <li className="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                                                                <div className="w-0 flex-1 flex items-center">
                                                                    <CreditCardIcon className="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true" />
                                                                    <span className="ml-2 flex-1 w-0 truncate">Titular Bancario: </span>
                                                                </div>
                                                                <div className="ml-4 flex-shrink-0">
                                                                    <p className="font-medium text-[#5ab9e5] hover:text-[#5ab9e5] ">
                                                                        {titularMop.numero}
                                                                    </p>
                                                                </div>
                                                            </li>
                                                        }

                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </main>
                                <div className="w-full flex justify-center   gap-[50%] p-5 ">
                                    <div className="w-[47%] flex justify-between gap-[30px] ml-[20px] ">
                                        <ButtonGeneric funtion={atras} text={"Volver"} />
                                        <ButtonGeneric funtion={Print} text={"Imprimir"} />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default DomiciliacionConfirmation;
